import { aiService } from '../../helpers/services/activeIngredient.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const AI_MODULE = 'activeIngredient'; 

// define action 
export const GET_ALL_AIS = 'getAllAIs';
export const GET_AI = 'getAI';
export const UPDATE_AI = 'updateAI';
export const CREATE_AI = 'createAI';
export const UPDATE_AI_STATUS = 'updateAIStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_AIS_REQUEST = "getAllAIs";
const GET_AI_REQUEST = "getAI";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_AIS]({ commit }, { filter }) {
        aiService
            .getAllAIs(filter)
            .then(
                (result) => {
                    commit(GET_ALL_AIS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_AI]({ commit }, { id }) {
       await aiService
            .getAI(id)
            .then(
                (result) => {
                    commit(GET_AI_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_AI]({ commit }, { data }) {
        commit(REQUEST)
        aiService
            .updateAI(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.activeIngredient')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_AI]({ commit }, { data }) {
        commit(REQUEST)
        aiService
            .createAI(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.activeIngredient')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_AI_STATUS]({ dispatch }, { filter, data }) {
        aiService
            .updateAIStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_AIS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "AI-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_AIS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_AI_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            name: o.name,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at)
        }
    }
}


